import { defineMessages } from 'react-intl';

export const buttonMessages = defineMessages({
  DialogAcceptButton: {
    defaultMessage: 'Zustimmen',
    id: 'Payback.Dialog.AcceptButton',
  },
  DialogDeclineButton: {
    defaultMessage: 'Widerrufen',
    id: 'Payback.Dialog.DeclineButton',
  },
  DialogUpdateButton: {
    defaultMessage: 'Aktualisieren',
    id: 'Payback.Dialog.UpdateButton',
  },
});
